// ?-----------------------------------------------------------------
// ? MAPBOXJS CUSTOMIZATION FUNCTIONALITY
// ?-----------------------------------------------------------------

// Creates the API token that we are using for this mapbox specifically.
mapboxgl.accessToken =
  "pk.eyJ1IjoiYmlrdHJpeCIsImEiOiJjbGZjdXR4Y2wxaXVvM3JzMDZyazU5NHI0In0.WP2vRnps-mbnHdaY5F_BUA";
const map = new mapboxgl.Map({
  container: "map",
  style: "mapbox://styles/biktrix/cl9rcrq2k008b15khmio95h86",
  center: [-96.369, 45.836],
  zoom: 3,
  minZoom: 3,
});

// Adds all control functionality to the mapbox
map.addControl(new mapboxgl.NavigationControl());

// Creates the geoCoder, so we can have a search function
const geocoder = new MapboxGeocoder({
  accessToken: mapboxgl.accessToken,
  mapboxgl: mapboxgl,
  marker: true,
  placeholder: "Enter your address here...",
  flyTo: {
    maxZoom: 5,
  },
});

map.addControl(geocoder, "top-left");

// All local variables
var mapBoxContainer = document.querySelector(".map_box_container");
var searchRecapNumber = document.querySelector("#search-recap_number");
var searchRecapLocation = document.querySelector("#search-recap_location");
var searchBarGeocoder = document.querySelector(".mapboxgl-ctrl-geocoder");
var sidebarHeader = document.querySelector(".sidebar_content .heading");
var searchBarInput = searchBarGeocoder.querySelector(
  ".mapboxgl-ctrl-geocoder--input"
);
var searchClear = document.querySelector("#clear_btn");

// Preappending the searchbar to the side menu
sidebarHeader.prepend(searchBarGeocoder);

/**buildLocationList(stores)
 *
 * Creates the cards for all local stores that is listed in the "dealer" layer
 * @param {stores} = The JSON codeline for all listed stores in layer "dealer"
 */

function buildLocationList(stores) {
  for (const store of stores) {
    // Prepare to create all item cards
    const listings = document.getElementById("listings");
    const listing = listings.appendChild(document.createElement("div"));
    listing.id = `listing-${store.id}`;
    listing.className = "map-item card sm-border-r";
    listing.setAttribute("aria_map-name", `${store.properties.title}`);
    if (store.properties.type) {
      listing.setAttribute("aria_map-type", `${store.properties.type}`);
    }

    const link = listing.appendChild(document.createElement("button"));
    link.setAttribute("type", "button");
    link.href = "#";
    link.className = "map-item_container";
    link.id = `link-${store.id}`;

    const header = link.appendChild(document.createElement("div"));
    header.className = "map-item_header";

    var title = header.appendChild(document.createElement("h4"));
    title.innerHTML = `${store.properties.title}`;

    if (store.properties.distance) {
      var distance = header.appendChild(document.createElement("span"));
      const roundedDistance = Math.round(store.properties.distance * 100) / 100;
      distance.innerHTML += `<div class="map-item_distance">${roundedDistance} Mi</div>`;
    }

    const details = link.appendChild(document.createElement("div"));
    details.className = "map-item_details";
    if (store.properties.addressline) {
      var addressline = details.appendChild(document.createElement("h5"));
      addressline.innerHTML += `${store.properties.addressline}`;
      var addressline2 = details.appendChild(document.createElement("span"));
      addressline2.innerHTML += `${store.properties.addressline2}`;
    }

    if (store.properties.type) {
      var type = details.appendChild(document.createElement("div"));
      type.classList.add("map-item_icons");
      if (store.properties.type === "showroom") {
        var showroom = type.appendChild(document.createElement("img"));
        showroom.setAttribute(
          "src",
          "//www.biktrix.ca/cdn/shop/t/119/assets/map-icon_biktrix-black.svg?v=66795612472901833241757629474"
        );
      }
    }

    if (store.properties.directions) {
      var directions = details.appendChild(document.createElement("a"));
      directions.innerHTML +=
        '<i class="fas fa-directions"></i> Get Directions';
      directions.setAttribute("target", "_blank");
      directions.href = `${store.properties.directions}`;
    }

    if (store.properties.phone) {
      var phone = details.appendChild(document.createElement("a"));
      phone.innerHTML +=
        '<i class="fas fa-phone-alt"></i>' + `${store.properties.phone}`;
      phone.href = "tel:" + `${store.properties.phone}`;
    }

    if (store.properties.website) {
      var website = details.appendChild(document.createElement("a"));
      website.setAttribute("target", "_blank");
      website.innerHTML += '<i class="fas fa-globe"></i> Go To Website';
      website.href = `${store.properties.website}`;
    }

    // Add an anchor to the card
    link.addEventListener("click", function () {
      if (link.id === `link-${store.id}`) {
        var long, lat;

        if (store.properties.longatude) {
          long = `${store.properties.longatude}`;
        }

        if (store.properties.langitude) {
          lat = `${store.properties.langitude}`;
        }

        flyToStore(store);
        createPopUp(store, long, lat);
      }

      // Create class for active cards
      const activeItems = document.querySelectorAll(".map-item.active");
      activeItems.forEach((activeItem) => {
        activeItem.classList.remove("active");
      });
      this.parentNode.classList.add("active");
    });
  }
}

/* END FUNCTION */

/**updateSearchRecap(stores, items, input, num, location)
 *
 * Updates search recap to fit all functionality and correct information
 * @param {stores} = The JSON codeline for all listed stores in layer "dealer"
 * @param {items} = Map Items from the listing
 * @param {input} = Search box input that identifies the location
 * @param {num} = Number of stores listed for when the search is finished
 * @param {location} = Location printed when posted beside the number span
 */
function updateSearchRecap(stores, items, input, num, location) {
  var count = 0;
  var locationText = input.value;
  var distanceLength = 150;

  locationText = locationText.split(",");
  locationText = locationText.slice(-3);
  locationText.pop();
  locationText = locationText.toString();

  for (const store of stores) {
    if (store.properties.distance) {
      var distance = `${store.properties.distance}`;
      if (distance < distanceLength) {
        count = count + 1;
      } else {
      }
    }
  }

  // Convert and change distance from each item

  for (const item of items) {
    var itemDistance = item.querySelector(".map-item_distance").innerText;
    itemDistance = itemDistance.replace("Mi", "");

    if (itemDistance < distanceLength) {
      item.classList.remove("hidden");
    } else {
      item.classList.add("hidden");
    }
  }

  // Final print of the search recap

  num.textContent = count;
  location.textContent = "near " + locationText;
}

/* END FUNCTION */

/**flyToStore(currentFeature)
 *
 * Flys the selected store on map
 * @param {currentFeature} = Current map selected to fly too
 */
function flyToStore(currentFeature) {
  map.flyTo({ center: currentFeature.geometry.coordinates, zoom: 5 });
}

/* END FUNCTION */

/**createPopUp(currentFeature, x, y)
 *
 * Creates pop up on mapbox with the card information
 * @param {currentFeature} = Current map selected to fly too
 * @param {x} = X coordinates for pop up on map
 * @param {y} = Y coordinates for pop up on map
 */
function createPopUp(currentFeature, x, y) {
  const popUps = document.getElementsByClassName("mapboxgl-popup");

  /** Check if there is already a popup on the map and if so, remove it */
  if (popUps[0]) popUps[0].remove();

  var coordinates = [y, x];

  // Set popup coordinates
  if (x == null || y == null) {
    var long = currentFeature.geometry.coordinates[0];
    var lat = currentFeature.geometry.coordinates[1];

    coordinates = [long, lat];
  }

  // Creates pop up styling

  const popup = new mapboxgl.Popup({
    offset: 15,
    closeOnClick: false,
    focusAfterOpen: false,
  })
    .setLngLat(coordinates)
    .setHTML(
      `<h4>${currentFeature.properties.title}</h4>
                <h5>${currentFeature.properties.addressline}</h5>
                <span>${currentFeature.properties.addressline2}</span>
                <a target="_blank" href="${currentFeature.properties.directions}"><i class="fas fa-directions"></i></i>Get Directions</a>
                <a href="tel:${currentFeature.properties.phone}"><i class="fas fa-phone-alt"></i>${currentFeature.properties.phone}</a>
                <a target="_blank" href="${currentFeature.properties.website}"><i class="fas fa-globe"></i>Go To Website</a>`
    )
    .addTo(map);
}

/* END FUNCTION */

// All functionality for when map is loaded
map.on("load", () => {
  geocoder.clear();
  // Creates the Stores Listing and filters out duplicates
  const layerFeatures = map.querySourceFeatures("composite", {
    sourceLayer: "Retail_Sellers_Latest",
  });
  const layerFeaturesAddress = new Set();

  const stores = layerFeatures.filter((item) => {
    const ADDRESS = item.properties.addressline;
    if (!layerFeaturesAddress.has(ADDRESS)) {
      layerFeaturesAddress.add(ADDRESS);
      return true;
    }
    return false;
  });

  console.log(layerFeatures);

  // const stores = layerFeatures.filter((item, index) => ! layerFeaturesTitles.includes(item.properties.title, index + 1));

  // All functionality for when geoCoder has results
  geocoder.on("result", (event) => {
    const searchResult = event.result.geometry;
    const options = {
      units: "miles",
    };
    for (const store of stores) {
      store.properties.distance = turf.distance(
        searchResult,
        store.geometry,
        options
      );
    }

    // Resort stores to fit the search
    stores.sort((a, b) => {
      if (a.properties.distance > b.properties.distance) {
        return 1;
      }
      if (a.properties.distance < b.properties.distance) {
        return -1;
      }
      return 0; // a must be equal to b
    });

    // Remove all map listing when searching
    const listings = document.getElementById("listings");
    while (listings.firstChild) {
      listings.removeChild(listings.firstChild);
    }

    // Recreate listing that sorts the map listings according to search results
    buildLocationList(stores);

    const MapItems = document.querySelectorAll(".map-item");
    updateSearchRecap(
      stores,
      MapItems,
      searchBarInput,
      searchRecapNumber,
      searchRecapLocation
    );

    var long, lat;

    if (stores[0].properties.longatude) {
      var long = `${stores[0].properties.longatude}`;
    }

    if (stores[0].properties.langitude) {
      var lat = `${stores[0].properties.langitude}`;
    }

    // Prep to create pop up
    createPopUp(stores[0], long, lat);

    // Highlight the first item in listing
    const activeListing = document.getElementById(`listing-${stores[0].id}`);
    activeListing.classList.add("active");

    // FILTERING OPTIONSET
    var filterInputs = document.querySelectorAll(".mapbox-filter_input");
    var mapItem = document.querySelectorAll(".map-item");

    for (const input of filterInputs) {
      input.addEventListener("change", (event) => {
        var layerID = input.id.replace("filter-", "");

        if (input.checked) {
          map.setFilter("dealers", [
            "match",
            ["get", "type"],
            ["showroom"],
            true,
            false,
          ]);
          for (const item of mapItem) {
            if (item.getAttribute("aria_map-type") != layerID) {
              item.style.display = "none";
            }
          }
        } else {
          map.setFilter("dealers", null);
          for (const item of mapItem) {
            item.style.display = "block";
          }
        }
      });
    }
  });

  if (map.loaded()) {
    searchRecapNumber.textContent = stores.length;
    buildLocationList(stores);
    mapBoxContainer.classList.remove("loading");
  }
  map.resize();

  // FILTERING OPTIONSET
  var filterInputs = document.querySelectorAll(".mapbox-filter_input");
  var mapItem = document.querySelectorAll(".map-item");

  for (const input of filterInputs) {
    // Prepare Filtering For Showrooms
    input.addEventListener("change", (event) => {
      var layerID = input.id.replace("filter-", "");

      if (input.checked) {
        map.setFilter("dealers", [
          "match",
          ["get", "type"],
          ["showroom"],
          true,
          false,
        ]);
        for (const item of mapItem) {
          if (item.getAttribute("aria_map-type") != layerID) {
            item.style.display = "none";
          }
        }
      } else {
        map.setFilter("dealers", null);
        for (const item of mapItem) {
          item.style.display = "block";
        }
      }
    });
  }

  // Clear all information when clicking clear button
  searchClear.addEventListener("click", function () {
    const MapItems = document.querySelectorAll(".map-item");
    clearMapSearch(stores, MapItems, searchRecapNumber, searchRecapLocation);
    map.setFilter("dealers", null);
    for (const input of filterInputs) {
      input.checked = false;
    }
    for (const item of mapItem) {
      item.style.display = "block";
    }
  });
});

// Functionality when map is clicked on
map.on("click", (event) => {
  const features = map.queryRenderedFeatures(event.point, {
    layers: ["dealers"],
  });

  if (!features.length) return;

  const clickedPoint = features[0];

  var long, lat;

  if (features[0].properties.longatude) {
    var long = `${features[0].properties.longatude}`;
  }
  if (features[0].properties.langitude) {
    var lat = `${features[0].properties.langitude}`;
  }

  flyToStore(clickedPoint);
  createPopUp(clickedPoint, long, lat);

  const activeItems = document.querySelectorAll(".map-item.active");
  const mapItems = document.querySelectorAll(".map-item");

  if (activeItems.length != 0) {
    activeItems.forEach((activeItem) => {
      activeItem.classList.remove("active");
    });
  }

  var clickPointTitle = `${features[0].properties.title}`;

  const listing = document.querySelector(
    '.map-item[aria_map-name="' + clickPointTitle + '"]'
  );
  listing.scrollIntoView({ behavior: "smooth", block: "center" });
  listing.classList.add("active");
});

/**JSONsuccess(pos)
 *
 * Run function when JSON has been successfully grabbed
 * @param {pos} = Coordinates for API
 */
function JSONsuccess(pos) {
  const crd = pos.coords;
  var latitude = `${crd.latitude}`;
  var longitude = `${crd.longitude}`;

  /**getFinalData(data)
   *
   * Grab final data to geo reverse the coordinates
   * @param {data} = Data for the API
   */
  function getFinalData(data) {
    var mapBoxContainer = document.querySelector(".map_box_container");
    var suggestionContainer = document.querySelector(
      ".suggestions-wrapper .suggestions"
    );

    mapBoxContainer.classList.remove("loading");
    suggestionContainer.style.display = "none";

    geocoder.query(data);
  }

  /* END FUNCTION */

  /**loadJson(lat, long)
   *
   * Loading the API JSON to grab the local location
   * @param {lat} = Lat of the coordinates
   * @param {long} = long of the coordinates
   */
  function loadJson(lat, long) {
    var postalCode;
    var coordinates = lat + "," + long;
    var apiKey = "AIzaSyCljcMcJVULh71jk8Sa8mt0apIIhRV4mlA";

    var xhttp = new XMLHttpRequest();
    xhttp.open(
      "GET",
      "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
        coordinates +
        "&key=" +
        apiKey,
      true
    );
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        var data = JSON.parse(this.responseText);
        var location = data.results[0].address_components[6].long_name;
        getFinalData(location);
      }
    };
    xhttp.send();
  }

  /* END FUNCTION */

  loadJson(latitude, longitude);
}

/* END FUNCTION */

function JSONerror(err) {
  console.warn(`ERROR(${err.code}): ${err.message}`);
}

/**grabCurrentLocation ()
 *
 * Grabs the current location and uses the API to reverse geoCoder
 */

function grabCurrentLocation() {
  var mapBoxContainer = document.querySelector(".map_box_container");

  geocoder.clear();
  mapBoxContainer.classList.add("loading");
  navigator.geolocation.getCurrentPosition(JSONsuccess, JSONerror);
}

/* END FUNCTION */

/**clearMapSearch (stores, items, number, location)
 *
 * Clears all data after search
 * @param {stores} = Store listing through the layer "dealers"
 * @param {items} = Items on the sidebar
 * @param {number} = Number of stores printed
 * @param {location} = Location printed beside number
 */
function clearMapSearch(stores, items, number, location) {
  geocoder.clear();
  const popUps = document.getElementsByClassName("mapboxgl-popup");

  /** Check if there is already a popup on the map and if so, remove it */
  if (popUps[0]) popUps[0].remove();

  for (const item of items) {
    item.classList.remove("hidden");
    item.classList.remove("active");
    item.style.display = "block";
    var distance = item.querySelector(".map-item_header span");
    if (distance != null) {
      distance.remove();
    }
  }

  location.textContent = "";
  number.textContent = stores.length;

  map.flyTo({
    center: [-96.369, 45.836],
    zoom: 3,
  });
}

/* END FUNCTION */
